import { render } from "./PondManagement.vue?vue&type=template&id=4a92ccf8"
import script from "./PondManagement.vue?vue&type=script&lang=js"
export * from "./PondManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__